<template>
  <div class="overlay">
    <div class="intensive-care-modal">
      <button class="close mt-2 mr-2 bg-light">
        <b-icon-x @click="$emit('close')" />
      </button>
      <div class="full-container mt-2">
        <div class="full-column">
          <div class="">
            <h4 class="fs12 text-uppercase">INTENSIVE CARE{{petName ? ' FÜR '+petName : ''}} BESTELLEN</h4>
          </div>
          <div class="">
            <p>
              <span class="font-weight-bolder"
                >futalis intensive care Low Fat</span
              >
              ist ein standardisiertes Alleinfuttermittel für akute
              Magen-Darm-Probleme, insbesondere bei Durchfall oder zum Anfüttern
              bei Pankreatitis. Bestellen Sie hier direkt für Ihren Patienten.
            </p>
          </div>
          <div class="full-column column-left">

            <div class="full-column">
              <div class="d-block clearfix">
                <div class="onethird pl-0 aligntext">Gewicht:</div>
                <div class="onethird">
                  <input
                    :value="petWeight"
                    type="text"
                    class="intensive-care-input"
                  />
                </div>
                <div class="onethird pl-0 aligntext">kg</div>
              </div>
              <div class="mt-2 d-block clearfix">
                <div class="onethird pl-0 aligntext">Fütterungsdauer:</div>
                <div class="onethird">
                  <input
                    v-model="numberOfDays"
                    @input="calculateIntensiveCare"
                    type="number"
                    class="intensive-care-input no-arrows"
                  />
                </div>
                <div class="onethird pl-0 aligntext">Tage</div>
              </div>

              <div class="weight-total">
                <span class="font-weight-bolder">Benötigte Menge:</span> {{dailyAmount}} g pro Tag {{secondAmountOption}}
              </div>

              <div class="food-options-container">
                <table class="food-options text-center" cellspacing="2px">
                  <tr>
                    <th class="food-options-column1">Dosengröβe</th>
                    <th>200 g</th>
                    <th>400 g</th>
                    <th>800 g</th>
                  </tr>
                  <tr>
                    <td class="font-weight-bolder">Benötigte Anzahl</td>
                    <td>{{ amount["200 g"]}}</td>
                    <td>{{ amount["400 g"]}}</td>
                    <td>{{ amount["800 g"]}}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bolder">Preis</td>
                    <td>{{ price["200 g"]}} €</td>
                    <td>{{ price["400 g"]}} €</td>
                    <td>{{ price["800 g"]}} €</td>
                  </tr>
                </table>
              </div>

              <div class="col-sm-12 mt-2 mobile-only">
                <a class="black-link -underline" href="javascript:void(0)" @click="showIngredients">Zusammensetzung</a>
                <a class="black-link float-right" href="javascript:void(0)" @click="showComposition">Inhaltsstoffe</a>
              </div>

              <div class="order-section">
                <div class="full-column" style="padding-top:1px;">
                  <div class="col-sm-12 mt-2">
                    <h4 class="font-weight-bolder">Ihre Bestellung</h4>
                  </div>
                  <div class="col-sm-12">
                    <p>
                      Bestellen Sie 6 oder mehr Dosen und sparen Sie 10 Cent pro Dose.
                    </p>
                  </div>

                  <div class="col-sm-12 d-block clearfix order-section-data">
                    <div class="onehalf aligntext font-weight-bolder">Dosengröβe:</div>
                    <div class="onehalf">
                      <select type="text" v-model="selectedOption" class="select-box">
                        <option value="" selected disabled>Optionen</option>
                        <option value="200 g">200 g</option>
                        <option value="400 g">400 g</option>
                        <option value="800 g">800 g</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-sm-12 d-block clearfix mt-1 order-section-data">
                    <div class="onehalf aligntext font-weight-bolder">Bestellmenge:</div>
                    <div class="onehalf">
                      <input type="number" v-model="quantity" class="intensive-care-input no-arrows" />
                    </div>
                  </div>

                  <div class="price-section">
                    <p>
                      Preis:
                      <span class="font-weight-bolder font-big-price">{{totalPrice}} €</span>
                      <br />
                      <span class="font-footer-small ml-2">(inkl. 7 % MwSt.)</span>
                    </p>
                  </div>

                  <div class="clearfix"></div>

                </div>
              </div>
            </div>
          </div>

          <div class="full-column column-right">
            <div class="full-column">
              <div class="col-sm-12 mobile-hidden">
                <img
                  width="100%"
                  alt="intensive care"
                  src="https://media.futalis.com/futalis/interface/intensive-care.png"
                />
              </div>
              <div class="col-sm-12 mt-2 desktop-only">
                <a class="black-link -underline" href="javascript:void(0)" @click="showIngredients">Zusammensetzung</a>
                <a class="black-link float-right" href="javascript:void(0)" @click="showComposition">Inhaltsstoffe</a>
              </div>
              <div class="col-sm-12 mt-3 mobile-hidden">
                <p>
                  Bitte beachten Sie bei Allergiepatienten die Zusammensetzung
                  des Produktes.
                </p>
              </div>
              <div class="col-sm-12 text-center px-4 ic-button">
                <button
                    class="submit-intensive-btn"
                    @click="addIntensiveCareToCart()"
                >
                  intensive care bestellen
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import router from "@/modules/router/config";
import {getCookie} from "@/helpers/userHelper";

export default {
  name: 'IntensiveCare',
  props: ['weight', 'petName', 'petId'],
  data() {
    return {
      numberOfDays: 0,
      secondAmountOption: '',
      amount: {
        '200 g': 0,
        '400 g': 0,
        '800 g': 0
      },
      price: {
        '200 g': 0.0,
        '400 g': 0.0,
        '800 g': 0.0
      },
      selectedOption: '',
      quantity: 0
    };
  },
  methods: {
    calculateIntensiveCare() {
      const overallAmount = this.dailyAmount * this.numberOfDays;

      if (overallAmount > 0) {
        this.secondAmountOption = 'oder ' + overallAmount + ' g für ' + this.numberOfDays + ' Tage';
        this.amount = {
          '200 g': Math.ceil(overallAmount / 200),
          '400 g': Math.ceil(overallAmount / 400),
          '800 g': Math.ceil(overallAmount / 800)
        };
        this.price = {
          '200 g': this.formatPrice(this.amount['200 g'] * parseFloat(this.productsPrices['200 g'])
          ),
          '400 g': this.formatPrice(this.amount['400 g'] * parseFloat(this.productsPrices['400 g'])
          ),
          '800 g': this.formatPrice(this.amount['800 g'] * parseFloat(this.productsPrices['800 g'])
          )
        };
        for (const [key, val] of Object.entries(this.productsTierPrices)) {
          for (let i = 0; i < this.productsTierPrices[key].length; i++) {
            if (this.amount[key] >= val[i][0]) {
              this.price[key] = this.formatPrice(this.amount[key] * parseFloat(val[i][1]));
            }
          }
        }
      } else {
        this.amount = {
          '200 g': 0,
          '400 g': 0,
          '800 g': 0
        };
        this.price = {
          '200 g': 0.0,
          '400 g': 0.0,
          '800 g': 0.0
        };
        this.secondAmountOption = '';
      }
    },
    formatPrice(price) {
      return (
        parseFloat(price)
          .toFixed(2)
          .replace('.', ',')
      );
    },
    async addIntensiveCareToCart() {
      const promise = await this.$store.dispatch('homeModule/addIntensiveCareToCart', {
        option: this.selectedOption,
        qty: this.quantity
      });

      let itemPrice = parseFloat(this.productsPrices[this.selectedOption]);
      let itemQty = parseInt(this.quantity);
      gtag("event", "add_to_cart", {
        currency: "EUR",
        value: itemPrice * itemQty,
        items: [
          {
            id: this.products[this.selectedOption].id,
            item_id: this.products[this.selectedOption].sku,
            item_name: this.products[this.selectedOption].name,
            affiliation: 'interface',
            discount: 0,
            item_category: 'vetshop',
            item_category2: 'Intensive care',
            price: itemPrice,
            quantity: itemQty,
            google_business_vertical: 'retail'
          }
        ]
      });

      if (promise.success === true) {
        this.$emit('close'); // close IC popup
        this.$store.commit('addressBookModule/closeAddressBook'); // close addressbook
        if (this.petId != null) {
          if (this.$route.path == '/cart/'+this.petId) {
            await this.$store.dispatch('checkOutModule/getCartContent', getCookie('client_id'));
          } else {
            await router.push({
              name: `checkout`,
              params: {
                petId: this.petId
              }
            });
          }
        } else {
          if (this.$route.name === 'checkout') {
            await this.$store.dispatch('checkOutModule/getCartContent', getCookie('client_id'));
          } else {
            await router.push({name: `checkout`});
          }
        }

      } else {
        this.$swal({
          text: promise.error,
          showCancelButton: false,
          showConfirmButton: true,
          confirmButtonColor: '#2778c4',
        });
      }
    },
    showIngredients() {
      this.$swal({
        title: 'Zusammensetzung',
        text: 'Huhn (Muskelmagen, Herzmuskel), Reis, Kartoffeln, Hüttenkäse, Möhren, Inulin, Rübentrockenschnitzel, Lachsöl, Vollei, Flohsamenschalen (0,4 %), Kamille (0,3 %)',
        showCancelButton: false,
        showConfirmButton: true,
        confirmButtonColor: '#a8c014'
      });
    },
    showComposition() {
      this.$swal({
        title: 'Inhaltsstoffe',
        html: '<div class="IC-comp-col">'
              +'Feuchtigkeit: 75,7 %<br>Rohprotein: 6,5 %<br>Rohfett: 1,9 %<br>Rohfaser: 0,5 %<br>Rohasche: 1,5 %<br>NfE: 13,9 %<br>ME: 0,4 MJ/100 g<br>ME: 0,37 MJ/100 g<br>(Diätfuttermittel)'
            +'</div>'
            +'<div class="IC-comp-col">'
              +'Calcium: 0,23 %<br>Phosphor: 0,17 %<br>Natrium: 0,11 %<br>Magnesium: 0,02 %<br>Kalium: 0,19 %<br>Eisen: 32 mg/kg<br>Zink: 21 mg/kg<br>Kupfer: 2,3 mg/kg<br>Jod: 0,34 mg/kg<br>Vitamin A: 2300 I.E./kg<br>'
              +'Vitamin D: 230 I.E./kg<br>Vitamin E: 23 mg/kg<br>Vitamin B1: 0,55 mg/kg<br>Viamin B6: 1,66 mg/kg<br>Vitamin B12: 0,014 mg/kg<br>Biotin: 0,046 mg/kg<br>Folsäure: 0,349 mg/kg'
            +'</div>',
        showCancelButton: false,
        showConfirmButton: true,
        confirmButtonColor: '#a8c014'
      });
    }
  },
  computed: {
    ...mapState({
      productsPrices: state => state.homeModule.intensiveCareProductPrices,
      productsTierPrices: state => state.homeModule.intensiveCareProductTierPrices,
      products: state => state.homeModule.intensiveCareProducts,
    }),
    totalPrice: {
      get() {
        let price = 0.0;
        if (this.selectedOption !== '' && this.quantity > 0) {
          if (this.selectedOption in this.productsTierPrices) {
            let tierPrice = 0.0;
            for (const [key, val] of Object.entries(this.productsTierPrices)) {
              if (key === this.selectedOption) {
                let sortedTierPrices = val.sort((a, b) => b[0] - a[0])
                for (let i = 0; i < sortedTierPrices.length; i++) {
                  if (parseInt(sortedTierPrices[i][0]) <= parseInt(this.quantity)) {
                    tierPrice = sortedTierPrices[i][1];
                  }
                }
                if (tierPrice == 0.0) {
                  tierPrice = parseFloat(this.productsPrices[this.selectedOption]);
                }
              }
            }
            price = this.formatPrice(this.quantity * tierPrice);
          }
          return price;
        }
        return '0,00';
      }
    },
    petWeight: {
      get() {
        if (isNaN(this.weight)) {
          return parseFloat(this.weight.replace(',', '.'));
        }
        return parseFloat(this.weight);
      }
    },
    dailyAmount: {
      get() {
        return Math.ceil((Math.pow(this.petWeight, 0.75) * 0.5 * 0.95) / 0.004);
      }
    }
  },
  watch: {
    quantity(newVal,oldVal){
      if(newVal < 0){
        this.quantity = 0;
      }
    },
    numberOfDays(newVal,oldVal){
      if(newVal < 0){
        this.numberOfDays = 0;
      }
    },
  },
  mounted() {
    this.$emit('getIntensiveCareProducts');
  }
};
</script>

<style scoped>
.overlay {
  overflow: auto;
}
.intensive-care-modal {
  width: 750px;
  height: 700px;
  background-color: #ffffff;
  position: absolute;
  font-size: 0.8rem;
  margin-left: -350px;
  top: 15%;
  left: 50%;
  color: #777;
  border-radius: 5px;
}
.intensive-care-modal input {
  font-weight: normal;
}
.intensive-care-input {
  display: flex;
  width: 100%;
  font-weight: bold;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 13px;
  color: #495057;
  background: #fff;
  border: 1px solid #e6e7d5;
  border-radius: 0;
}
.food-options {
  font-size: 0.9rem;
  border-collapse: unset;
  width: 100%;
}
.food-options > tr > th {
  color: #fff;
  /*border: 2px solid #ffffff;
  background-color: #02a3c1;*/
  background-color: #57C1D5;
  padding: 0.5rem 1rem;
}
.food-options > tr > td {
  /*color: #555555;
  background-color: #d0e9ef;*/
  background-color: #eef9fd;
  /*border: 2px solid #ffffff;*/
  padding: 0.375rem 0.75rem;
}
.order-section {
  /*border: 1px solid #02a3c1;*/
  background-color: #eef9fd;
}
.description {
  font-size: 0.8rem;
}
.font-big-price {
  font-size: 1.5rem;
}
.select-box {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  color: #495057;
  font-size: 13px;
  background: #fff
    url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e")
    no-repeat right 0.75rem center/8px 10px;
  border: 1px solid #e6e7d5;
  appearance: none;
}
.black-link {
  color: black;
  text-decoration: underline;
}
.submit-intensive-btn {
  display: inline-block;
  vertical-align: middle;
  border: 1px solid transparent;
  padding: 0.7rem 1.2rem;
  background-size: cover;
  background-color: #57C1D5;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 0.92rem;
  color: #fefefe;
  text-decoration: none solid rgb(254, 254, 254);
  text-align: center;
  line-height: 1.5;
}
.submit-intensive-btn:hover {
  background-color: #02a4c0;
}

.onethird {
  width: 33%;
  float: left;
  padding: 0 5% 0 0;
}
.onehalf {
  width: 50%;
  float: left;
  padding: 0 5% 0 0;
}
.aligntext {
  padding-top: 9px !important;
}
.full-column {
  display: block;
  width: 100%;
}
.full-column.column-left {
  float: left;
  width: 60%;
}
.full-column.column-right {
  float: left;
  width: 40%;
  padding-left: 3%;
}
.weight-total {
  margin-top: 2rem;
}
.food-options-container {
  margin-top: 3rem;
}
.full-container {
  padding-left: 2rem;
  padding-right: 2rem;
}
.order-section {
  width: 100%;
  margin-top: 2rem;
}
.order-section-data {
  width: 60%;
}
.price-section {
  float: right;
  margin-right: 1rem;
  width: 40%;
  text-align: right;
}
.ic-button {
  margin-top: 3rem;
}
.no-arrows {
  -webkit-appearance: none;
  -moz-appearance: textfield;
}
.mobile-only {
  display: none;
}
.desktop-only {
  display: block;
}
@media (max-width: 768px) {
  .mobile-only {
    display: block !important;
  }
  .desktop-only {
    display: none !important;
  }
  .intensive-care-modal {
    width: 100vw;
    left: 0;
    margin: 0;
    top: 90px !important;
    font-size: 0.7rem;
    position: absolute;
    border-radius: 0;
  }
  h4.fs12 {
    font-size: 1.2rem !important;
  }
  .weight-total {
    margin-top: 1rem;
  }
  .food-options {
    font-size: 0.8rem;
  }
  .food-options-container {
    margin-top: 1rem;
  }
  .full-container {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }
  .full-column.column-left {
    width: 100%;
  }
  .full-column.column-right {
    width: 100%;
  }
  .order-section {
    margin-top: 1rem;
  }
  .price-section {
    margin-top: -55px;
  }
  .mobile-hidden {
    display: none;
  }
  .overlay {
    display: block;
    max-height: 1000000px;
    max-width: 1000000px;
    overflow: scroll;
  }
  .ic-button {
    margin-top: 1rem;
  }
}
</style>
